import React from 'react';
import { Route } from 'react-router-dom';
import StaffList from '@/pages/hr/StaffList';
import AddStaffPage from '@/pages/staff/AddStaffPage';
import StaffAttendance from '@/pages/hr/StaffAttendance';
import StaffAttendanceReport from '@/pages/hr/AttendanceReport';
import Payroll from '@/pages/hr/Payroll';
import PayrollReport from '@/pages/hr/PayrollReport';
import StaffLedger from '@/pages/hr/StaffLedger';
import PrintSalarySlip from '@/pages/hr/PrintSalarySlip';
import ResignBlock from '@/pages/hr/ResignBlock';
import ExperienceCertificate from '@/pages/hr/ExperienceCertificate';
import ReleavingLetter from '@/pages/hr/ReleavingLetter';
import DepartmentSetting from '@/pages/hr/DepartmentSetting';
import DesignationSetting from '@/pages/hr/DesignationSetting';
import MissedCheckouts from '@/pages/hr/MissedCheckouts';

import EditStaffPage from '@/pages/staff/EditStaffPage';
import StaffSalaryTemplate from '@/pages/hr/StaffSalaryTemplate';
import LeaveApproval from '@/pages/hr/LeaveApproval';
import RegularizationApproval from '@/pages/hr/RegularizationApproval';

// Staff I-Card
import StaffICardBuilder from '@/pages/hr/StaffICardBuilder';
import PrintStaffICard from '@/pages/hr/PrintStaffICard';
import StaffICardReport from '@/pages/hr/StaffICardReport';
import StaffDocumentsReport from '@/pages/hr/StaffDocumentsReport';

export const hrRoutes = (
  <React.Fragment>
    <Route path="hr/staff-list" element={<StaffList />} />
    <Route path="hr/add-staff" element={<AddStaffPage />} />
    <Route path="hr/edit-staff/:staffId" element={<EditStaffPage />} />
    <Route path="hr/attendance" element={<StaffAttendance />} />
    <Route path="hr/missed-checkouts" element={<MissedCheckouts />} />
    <Route path="hr/staff-salary" element={<StaffSalaryTemplate />} />
    <Route path="hr/attendance-report" element={<StaffAttendanceReport />} />
    <Route path="hr/payroll" element={<Payroll />} />
    <Route path="hr/payroll-report" element={<PayrollReport />} />
    <Route path="hr/staff-ledger" element={<StaffLedger />} />
    <Route path="hr/print-salary-slip" element={<PrintSalarySlip />} />
    <Route path="hr/resign-block" element={<ResignBlock />} />
    <Route path="hr/experience-certificate" element={<ExperienceCertificate />} />
    <Route path="hr/releaving-letter" element={<ReleavingLetter />} />
    <Route path="hr/department-setting" element={<DepartmentSetting />} />
    <Route path="hr/designation-setting" element={<DesignationSetting />} />
    <Route path="hr/leave-approval" element={<LeaveApproval />} />
    <Route path="hr/regularization-approval" element={<RegularizationApproval />} />
    {/* Staff I-Card */}
    <Route path="hr/staff-icard-builder" element={<StaffICardBuilder />} />
    <Route path="hr/print-staff-icard" element={<PrintStaffICard />} />
    <Route path="hr/staff-icard-report" element={<StaffICardReport />} />
    <Route path="hr/staff-documents-report" element={<StaffDocumentsReport />} />
  </React.Fragment>
);
